<template>
  <li
    class="tw-cursor-pointer tw-px-6 tw-py-4 hover:tw-bg-aside-300"
    @click="emitClick"
  >
    <slot />
  </li>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (event: "on-click"): void;
}>();

const emitClick = (): void => {
  emit("on-click");
};
</script>
